module.exports = __webpack_public_path__ + "img/no-sensor-marker.13e798dc.svg";